import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { ca } from '@cian/analytics';
import { getCianAnalyticsObjectPage } from '../../utils/tracking';
import { PHONE_CODE_SENDER_TO_LABEL } from './constants';

/**
 * Успешная регистрация
 */

export function trackRegistrationSuccess(_ref) {
  var socialType = _ref.socialType,
    senderType = _ref.senderType,
    source = _ref.source,
    isProfessional = _ref.isProfessional;
  var label = senderType ? PHONE_CODE_SENDER_TO_LABEL[senderType] : socialType || '';
  ca('eventSite', _objectSpread({
    name: 'oldevent',
    category: 'Registration',
    action: 'success',
    label: label
  }, (source || isProfessional) && {
    page: _objectSpread(_objectSpread({}, getCianAnalyticsObjectPage()), {}, {
      extra: {
        source: source,
        is_professional: isProfessional
      }
    })
  }));
}

/**
 * Подписка на новости
 */
export function trackWantsSubscription(source) {
  ca('eventSite', _objectSpread({
    name: 'oldevent',
    category: 'Subscription',
    action: 'send',
    label: 'news'
  }, source && {
    page: _objectSpread(_objectSpread({}, getCianAnalyticsObjectPage()), {}, {
      extra: {
        source: source
      }
    })
  }));
}

/**
 * Показ попапа "Отправлено письмо"
 */
export function trackRegistrationDonePopup(source) {
  ca('eventSite', _objectSpread({
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'verify_email_popup_show'
  }, source && {
    page: _objectSpread(_objectSpread({}, getCianAnalyticsObjectPage()), {}, {
      extra: {
        source: source
      }
    })
  }));
}

/**
 * Закрытие попапа "Отправлено письмо"
 */
export function trackRegistrationDonePopupClose(source) {
  ca('eventSite', _objectSpread({
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'verify_email_popup_got_it'
  }, source && {
    page: _objectSpread(_objectSpread({}, getCianAnalyticsObjectPage()), {}, {
      extra: {
        source: source
      }
    })
  }));
}

/**
 * Введен неверный код
 */
export function trackRegistrationSmsValidationFail(source) {
  ca('eventSite', _objectSpread({
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'Fail',
    label: 'phone_simple'
  }, source && {
    page: _objectSpread(_objectSpread({}, getCianAnalyticsObjectPage()), {}, {
      extra: {
        source: source
      }
    })
  }));
}